import { Checkbox, Form, Header } from "semantic-ui-react";
import ErrorsView from "./ErrorsView";
import { FormError } from "../models/FormError";

export interface FormData {
  useDefault: boolean;
  isPermitAssignee: boolean;
  mandatoryOnSubmission: boolean;
  shouldAuthorizePermit: boolean;
  authorizationDeclaration: string;
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
}

const EditPermitTypeRoleSettingsForm = ({ formData, formErrors, errors, onChange }: Props) => {
  const handleCheckboxChange = (_: any, { name, checked }: any) => {
    onChange({ ...formData, [name]: checked });
  };

  const handleChange = (_: any, { name, value }: any) => {
    onChange({ ...formData, [name]: value });
  };

  return (
    <>
      <Form>
        <Form.Field>
          <Checkbox
            name="useDefault"
            checked={formData.useDefault}
            label="Use default org-level settings"
            onChange={handleCheckboxChange}
          />
        </Form.Field>
        <Header as="h5" dividing>
          Permit workflow settings
        </Header>
        <Form.Group>
          <Form.Field width={5}>
            <Checkbox
              name="isPermitAssignee"
              checked={formData.isPermitAssignee}
              label="A permit team member"
              disabled={formData.useDefault}
              onChange={handleCheckboxChange}
            />
          </Form.Field>
          <Form.Field width={5}>
            <Checkbox
              name="mandatoryOnSubmission"
              checked={formData.mandatoryOnSubmission}
              label="Mandatory (on submission)"
              disabled={formData.useDefault || !formData.isPermitAssignee}
              onChange={handleCheckboxChange}
            />
          </Form.Field>
          <Form.Field width={6}>
            <Checkbox
              name="shouldAuthorizePermit"
              checked={formData.shouldAuthorizePermit}
              label="Signature required for permit authorization"
              disabled={formData.useDefault || !formData.isPermitAssignee}
              onChange={handleCheckboxChange}
            />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.TextArea
            name="authorizationDeclaration"
            value={formData.authorizationDeclaration}
            placeholder="Authorization declaration"
            disabled={formData.useDefault || !formData.shouldAuthorizePermit}
            onChange={handleChange}
            error={formErrors.authorizationDeclaration}
          />
        </Form.Group>
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default EditPermitTypeRoleSettingsForm;
